import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { paymentMethodsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type UseCheckIfUsedPaymentMutationProps = {
	paymentMethodId: string;
	onSuccess?: Function;
};

const useCheckIfUsedPaymentMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ paymentMethodId }: UseCheckIfUsedPaymentMutationProps) =>
			paymentMethodsService.checkIfUsedPaymentMethod(paymentMethodId),
		{
			onMutate() {
				dispatch(uiActions.showSpinnerOverlay());
			},
			onSuccess(data, { onSuccess }) {
				onSuccess?.(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useCheckIfUsedPaymentMutation;
